import React from 'react';
import LvTypography from './sections/typography';
import LvColors from './sections/colors';
import LvShadows from './sections/shadows';
export default function StyleGuidePage() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LvTypography, null), /*#__PURE__*/React.createElement(LvColors, null), /*#__PURE__*/React.createElement(LvShadows, null));
}